export default __webpack_public_path__ + "f3b6d581840af16c06909e47da73dc63.jpg";